"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addCategoryIdsToList = exports.MODULE = void 0;
exports.collapseCategory = collapseCategory;
exports.filterCategoriesBySupportedContentType = void 0;
exports.filterCategoriesByTitle = filterCategoriesByTitle;
exports.flattenCategoryList = exports.findCategoryById = exports.filterEmptyCategories = void 0;
exports.getCategoryIdTitleMapping = getCategoryIdTitleMapping;
exports.removeCategoryIdsFromList = exports.keyToModuleMap = exports.groupModuleTypes = exports.getUniqueNormalisedCategories = exports.getTypeFromModuleName = exports.getNonEmptyCategories = exports.getModuleTypeFromContentType = exports.getModuleRouteFromType = exports.getModuleNameFromType = exports.getMergedCategoryList = exports.getContentCategories = void 0;
exports.toggleCollapseCategory = toggleCollapseCategory;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _contentType = require("@insided/shared/utils/contentType");

var _toKebabCase = require("@insided/shared/utils/toKebabCase");

var _common = require("@insided/shared/utils/common");

var _reverseModuleTypeMap;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function collapseCategory(categories, id) {
  var categoriesMap = {};
  Object.entries(categories).map(function (_ref) {
    var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return Object.assign(categoriesMap, (0, _defineProperty2.default)({}, key, toggleCollapseCategory(value, id)));
  });
  return categoriesMap;
}

function toggleCollapseCategory(categories, id) {
  return categories.map(function (oldCategory) {
    var category = _objectSpread({}, oldCategory);

    if (category.id === id) {
      category.isCollapsed = !category.isCollapsed;
    }

    if (category.children.length > 0) {
      return _objectSpread(_objectSpread({}, category), {}, {
        children: toggleCollapseCategory(category.children, id)
      });
    }

    return category;
  });
}

function getCategoryIdTitleMapping(categories) {
  var mapping = {};

  var _iterator = _createForOfIteratorHelper(categories),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var category = _step.value;
      var childMapping = {};

      if (category.children.length > 0) {
        childMapping = getCategoryIdTitleMapping(category.children);
      }

      mapping = _objectSpread(_objectSpread({}, mapping), {}, (0, _defineProperty2.default)({}, category.id, category.title), childMapping);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return mapping;
}

var findCategoryById = function findCategoryById(categories, id) {
  var foundCategory = categories.find(function (category) {
    return category.id === id;
  });

  if (foundCategory) {
    return foundCategory;
  }

  var _iterator2 = _createForOfIteratorHelper(categories),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var category = _step2.value;

      if (category.children.length > 0) {
        foundCategory = findCategoryById(category.children, id);

        if (foundCategory) {
          return foundCategory;
        }
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return undefined;
};

exports.findCategoryById = findCategoryById;
var MODULE = {
  KNOWLEDGE_BASE: 'Knowledge Base',
  COMMUNITY: 'Community',
  GROUPS: 'Groups',
  IDEATION: 'Ideation',
  PRODUCT_UPDATES: 'Product Updates'
};
exports.MODULE = MODULE;
var moduleTypeMapping = {
  0: MODULE.COMMUNITY,
  1: MODULE.KNOWLEDGE_BASE,
  4: MODULE.GROUPS,
  7: MODULE.IDEATION,
  8: MODULE.PRODUCT_UPDATES
};
var reverseModuleTypeMapping = (_reverseModuleTypeMap = {}, (0, _defineProperty2.default)(_reverseModuleTypeMap, MODULE.COMMUNITY, 0), (0, _defineProperty2.default)(_reverseModuleTypeMap, MODULE.KNOWLEDGE_BASE, 1), (0, _defineProperty2.default)(_reverseModuleTypeMap, MODULE.GROUPS, 4), (0, _defineProperty2.default)(_reverseModuleTypeMap, MODULE.IDEATION, 7), (0, _defineProperty2.default)(_reverseModuleTypeMap, MODULE.PRODUCT_UPDATES, 8), _reverseModuleTypeMap);

var getModuleTypeFromContentType = function getModuleTypeFromContentType(type) {
  if (type === _contentType.CONTENT_TYPE_IDEA) {
    return [getTypeFromModuleName(_common.common.isModuleActive('categoriesV2IdeasAndPU') ? MODULE.COMMUNITY : MODULE.IDEATION)];
  } else if (type === _contentType.CONTENT_TYPE_PRODUCT_UPDATE) {
    return [getTypeFromModuleName(_common.common.isModuleActive('categoriesV2IdeasAndPU') ? MODULE.COMMUNITY : MODULE.PRODUCT_UPDATES)];
  } else {
    return [getTypeFromModuleName(MODULE.KNOWLEDGE_BASE), getTypeFromModuleName(MODULE.COMMUNITY), getTypeFromModuleName(MODULE.GROUPS)];
  }
};

exports.getModuleTypeFromContentType = getModuleTypeFromContentType;

var getModuleNameFromType = function getModuleNameFromType(type) {
  return moduleTypeMapping[type];
};

exports.getModuleNameFromType = getModuleNameFromType;

var getTypeFromModuleName = function getTypeFromModuleName(moduleType) {
  return reverseModuleTypeMapping[moduleType];
};

exports.getTypeFromModuleName = getTypeFromModuleName;

var getModuleRouteFromType = function getModuleRouteFromType(type) {
  return (0, _toKebabCase.textToKebab)(getModuleNameFromType(type));
};

exports.getModuleRouteFromType = getModuleRouteFromType;

var flattenCategoryList = function flattenCategoryList(categories) {
  var flatCategoryList = [];
  categories.forEach(function (category) {
    flatCategoryList.push({
      id: String(category.id),
      title: category.title,
      isContainer: category.isContainer
    });

    if (category.children.length > 0) {
      flatCategoryList.push.apply(flatCategoryList, (0, _toConsumableArray2.default)(flattenCategoryList(category.children)));
    }
  });
  return flatCategoryList;
};

exports.flattenCategoryList = flattenCategoryList;

var getMergedCategoryList = function getMergedCategoryList(groupedCategories) {
  var mergedCategoryList = [];
  Object.entries(groupedCategories).forEach(function (_ref3) {
    var _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
        categoryList = _ref4[1];

    mergedCategoryList.push.apply(mergedCategoryList, (0, _toConsumableArray2.default)(categoryList));
  });
  return mergedCategoryList;
};

exports.getMergedCategoryList = getMergedCategoryList;

var getContentCategories = function getContentCategories(flatCategoryList) {
  return flatCategoryList.filter(function (_ref5) {
    var isContainer = _ref5.isContainer;
    return !isContainer;
  });
};

exports.getContentCategories = getContentCategories;

var removeCategoryIdsFromList = function removeCategoryIdsFromList(categoryIdList, category, childrenContentCategories) {
  var childrenIds = childrenContentCategories.map(function (_ref6) {
    var id = _ref6.id;
    return id;
  });

  if (category.isContainer) {
    return categoryIdList.filter(function (_ref7) {
      var id = _ref7.id;
      return !childrenIds.includes(id);
    });
  }

  return categoryIdList.filter(function (_ref8) {
    var id = _ref8.id;
    return id !== String(category.id);
  });
};

exports.removeCategoryIdsFromList = removeCategoryIdsFromList;

var addCategoryIdsToList = function addCategoryIdsToList(categoryIdList, category, childrenContentCategories) {
  if (category.isContainer) {
    categoryIdList.push.apply(categoryIdList, (0, _toConsumableArray2.default)(childrenContentCategories));
  } else {
    categoryIdList.push.apply(categoryIdList, (0, _toConsumableArray2.default)(flattenCategoryList([category])));
  }

  return getUniqueNormalisedCategories(categoryIdList);
};

exports.addCategoryIdsToList = addCategoryIdsToList;

var getUniqueNormalisedCategories = function getUniqueNormalisedCategories(categories) {
  var seenIds = new Set();
  return categories.filter(function (category) {
    if (seenIds.has(category.id)) {
      return false;
    } else {
      seenIds.add(category.id);
      return true;
    }
  });
};

exports.getUniqueNormalisedCategories = getUniqueNormalisedCategories;

var getNonEmptyCategories = function getNonEmptyCategories(categoriesV2) {
  var nonEmptyCategories = {};

  for (var key in categoriesV2) {
    if (Object.prototype.hasOwnProperty.call(categoriesV2, key)) {
      var filteredCategories = filterEmptyCategories(categoriesV2[key]);

      if (filteredCategories.length > 0) {
        nonEmptyCategories[key] = filteredCategories;
      }
    }
  }

  return nonEmptyCategories;
};

exports.getNonEmptyCategories = getNonEmptyCategories;

var filterEmptyCategories = function filterEmptyCategories(categories) {
  return categories.map(function (category) {
    if (category.isContainer) {
      category.children = filterEmptyCategories(category.children);
    }

    return category;
  }).filter(function (category) {
    return !(category.isContainer && category.children.length === 0);
  });
};

exports.filterEmptyCategories = filterEmptyCategories;
var GroupModuleType = {
  PUBLIC_GROUPS: 4,
  PRIVATE_GROUPS: 5,
  HIDDEN_GROUPS: 6
};
var groupModuleTypes = [GroupModuleType.PUBLIC_GROUPS, GroupModuleType.PRIVATE_GROUPS, GroupModuleType.HIDDEN_GROUPS];
exports.groupModuleTypes = groupModuleTypes;
var keyToModuleMap = {
  community: MODULE.COMMUNITY,
  knowledgeBase: MODULE.KNOWLEDGE_BASE,
  ideation: MODULE.IDEATION,
  productUpdates: MODULE.PRODUCT_UPDATES,
  group: MODULE.GROUPS
};
exports.keyToModuleMap = keyToModuleMap;

var filterCategoriesBySupportedContentType = function filterCategoriesBySupportedContentType(categories, contentType) {
  if (!_common.common.isModuleActive('supportedContentTypes')) {
    return categories;
  }

  if (!contentType) {
    return categories;
  }

  var filteredCategories = {};
  Object.entries(categories).forEach(function (_ref9) {
    var _ref10 = (0, _slicedToArray2.default)(_ref9, 2),
        type = _ref10[0],
        categoryList = _ref10[1];

    if (Number(type) === getTypeFromModuleName(MODULE.COMMUNITY)) {
      var filtered = filterCategoryListBySupportedContentType(categoryList, contentType);

      if (filtered.length > 0) {
        filteredCategories[type] = filtered;
      }
    } else {
      filteredCategories[type] = categoryList;
    }
  });
  return filteredCategories;
};

exports.filterCategoriesBySupportedContentType = filterCategoriesBySupportedContentType;

var filterCategoryListBySupportedContentType = function filterCategoryListBySupportedContentType(categoryList, contentType) {
  if (!_common.common.isModuleActive('supportedContentTypes')) {
    return categoryList;
  }

  return categoryList.map(function (category) {
    var _category$supportedCo;

    if (category.isContainer) {
      var filteredChildren = filterCategoryListBySupportedContentType(category.children, contentType);

      if (filteredChildren.length === 0) {
        return null;
      }

      return _objectSpread(_objectSpread({}, category), {}, {
        children: filteredChildren
      });
    }

    var supportedContentTypes = (_category$supportedCo = category === null || category === void 0 ? void 0 : category.supportedContentTypes) !== null && _category$supportedCo !== void 0 ? _category$supportedCo : [_contentType.CONTENT_TYPE_ARTICLE, _contentType.CONTENT_TYPE_IDEA, _contentType.CONTENT_TYPE_QUESTION, _contentType.CONTENT_TYPE_CONVERSATION, _contentType.CONTENT_TYPE_PRODUCT_UPDATE];
    return supportedContentTypes !== null && supportedContentTypes !== void 0 && supportedContentTypes.includes(contentType) ? category : null;
  }).filter(function (category) {
    return category !== null;
  });
};

function filterCategoriesByTitle(categories, title) {
  return categories.filter(function (category) {
    if (category.title.toLowerCase().includes(title.toLowerCase())) {
      return true;
    }

    if (category.children.length > 0) {
      category.children = filterCategoriesByTitle(category.children, title);

      if (category.children.length > 0) {
        return true;
      }
    }

    return false;
  });
}